<template>
  <footer id="contact" class="bg-bg">
    <div class="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
        <div class="md:col-span-2">
          <div class="flex items-center gap-3 mb-4">
            <img src="/jiker-logo.png" alt="JIKER" class="w-9 h-9 border-2 border-border rounded-md">
            <span class="text-xl font-bold">JIKER</span>
          </div>
          <p class="text-text-secondary max-w-sm leading-relaxed">
            {{ $t('footer.description') }}
          </p>
        </div>

        <div>
          <h4 class="font-bold mb-4">{{ $t('footer.productsTitle') }}</h4>
          <ul class="space-y-2">
            <li v-for="product in products" :key="product.href">
              <a
                :href="product.href"
                target="_blank"
                rel="noopener noreferrer"
                class="text-text-secondary hover:text-text-primary transition-colors"
              >
                {{ product.label }}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 class="font-bold mb-4">{{ $t('footer.connectTitle') }}</h4>
          <ul class="space-y-2">
            <li>
              <a
                href="mailto:hello@jiker.ai"
                class="text-text-secondary hover:text-text-primary transition-colors"
              >
                hello@jiker.ai
              </a>
            </li>
            <li>
              <a
                href="https://github.com/jikerai"
                target="_blank"
                rel="noopener noreferrer"
                class="text-text-secondary hover:text-text-primary transition-colors"
              >
                {{ $t('footer.github') }}
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/jikerai"
                target="_blank"
                rel="noopener noreferrer"
                class="text-text-secondary hover:text-text-primary transition-colors"
              >
                {{ $t('footer.twitter') }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="pt-8 border-t border-border-light flex flex-col md:flex-row items-center justify-between gap-4">
        <p class="text-text-secondary text-sm">
          {{ $t('footer.copyright', { year: currentYear }) }}
        </p>
        <p class="text-text-secondary text-sm">
          {{ $t('footer.tagline') }}
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup>
const currentYear = new Date().getFullYear();

const products = [
  { label: 'looploop.chat', href: 'https://looploop.chat' },
  { label: 'looploop.run', href: 'https://looploop.run' },
  { label: 'looploop.vip', href: 'https://looploop.vip' },
  { label: 'llmpool.io', href: 'https://llmpool.io' },
  { label: 'Geek Academy', href: 'https://jikexueyuan.com' },
  { label: 'Geek Future School', href: 'https://jiker.com' },
];
</script>
